"use client";

import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import NotFoundPage from "../src/components/Error404/NotFoundPage";
import { useAppContext } from "@components/Provider";
import Sites from "src/constants/Sites";

/**
 * Root 404 for routes without a layout (e.g. postPageLayouts/[...post]).
 * Route groups that already provide a layout use their own not-found.js.
 */
const NotFound = () => {
  const { siteId, isMobile, isTablet, isNonClosableModalChecked } = useAppContext();

  if (siteId === Sites.OPENROADMEDIA) {
    return <NotFoundPage />;
  }

  return (
    <SingleColumnLayout
      siteId={siteId}
      isMobile={isMobile}
      isTablet={isTablet}
      isNonClosableModalChecked={isNonClosableModalChecked}
    >
      <NotFoundPage />
    </SingleColumnLayout>
  );
};

export default NotFound;
